module.exports = __webpack_public_path__ + "static/media/user-icon.551e5004.svg";